import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled, { createGlobalStyle } from 'styled-components';
import history from '../../../history';
import { cdnImage } from '../../../utils/core';
import { getUrlParams } from 'utils/core';
import {
    ORACLE_ELOQUA,
    HUBSPOT,
    SALESFORCE,
} from 'utils/constants/integrations';
import {
    ENTERPRISE_PLAN,
    BUSINESS_PRO_CL,
    SOCIAL_WEBINAR_PRO_EL,
} from 'hooks/metered-pricing/config';

const subscriptionType = [
    ENTERPRISE_PLAN,
    BUSINESS_PRO_CL,
    SOCIAL_WEBINAR_PRO_EL,
];
const subscriptionTypeFree = 'free';

const SelectCommunity = (props) => {
    const urlParams = getUrlParams();
    const { myCommunity, current } = useSelector((state) => state.Community);
    const [selectedCommunityId, setCommunity] = useState(false);
    const getRoleDescription = (role) => {
        return `You are ${role === 'owner' ? 'an admin' : 'an event manager'}`;
    };
    let list = myCommunity.list || [];
    const selectCommunity = (id) => {
        setCommunity(id);
    };
    const crmName = urlParams.crm && urlParams.crm.toUpperCase();
    list = useMemo(() => {
        if (Array.isArray(list) && list.length > 0) {
            switch (crmName) {
                case ORACLE_ELOQUA:
                case SALESFORCE:
                    return list.filter((item) =>
                        subscriptionType.includes(item?.subscription_type)
                    );
                    break;
                case HUBSPOT:
                    return list.filter(
                        (item) =>
                            item?.subscription_type &&
                            item.subscription_type.toLowerCase() !==
                                subscriptionTypeFree
                    );
                    break;
                default:
                    return list;
                    break;
            }
        }
    }, [crmName, list]);

    const communitySelectHandler = () => {
        if (selectedCommunityId) {
            if (urlParams.installid && crmName === ORACLE_ELOQUA) {
                window.location.replace(
                    `${process.env.REACT_APP_ELOQUA_URL}&state=${selectedCommunityId}&redirect_uri=${process.env.REACT_APP_ELOQUA_REDIRECT_URL}?installid=${urlParams.installid}`
                );
                return;
            }
            if (crmName === SALESFORCE) {
                history.push(
                    `/integrations?type=salesforce&communityId=${selectedCommunityId}`
                );
                return;
            }
            history.push(`/community-manager/${selectedCommunityId}/settings`);
        }
    };
    return (
        <PageWrapper>
            <OverrideGloablStyles />
            <Wrapper>
                <div className='imageCon'>
                    <img
                        src={cdnImage(
                            `/images/dashboard/events/laptop-button.svg`
                        )}
                        alt='laptop'
                    />
                </div>
                <div className='centerAllign'>
                    <p className='pageTitle'>Please select a community</p>
                    <p className='subTitle'>
                        {' '}
                        Select the community to continue
                    </p>
                </div>
                {list &&
                    list.map((item) => (
                        <div
                            key={item.communityId}
                            className={`chipContainer ${
                                selectedCommunityId === item.communityId &&
                                'selctedItem'
                            }`}
                            onClick={() => selectCommunity(item.communityId)}
                        >
                            <div className='imageConatiner'>
                                {item.community_image_url !== 'string' && (
                                    <img
                                        src={item.community_image_url}
                                        alt={item.name}
                                    />
                                )}
                            </div>
                            <div className='contentConatiner'>
                                <p className='title'>{item.name}</p>
                                <p className='subTitle'>
                                    {getRoleDescription(item.role)}
                                </p>
                            </div>
                        </div>
                    ))}
                <button
                    type='submit'
                    className='btn btn-primary buttonContainer'
                    onClick={communitySelectHandler}
                    disabled={!selectedCommunityId}
                >
                    Continue
                </button>
            </Wrapper>
        </PageWrapper>
    );
};
const PageWrapper = styled.div`
    position: relative;
    width: 84%;
    margin: 0 auto;
    @media (max-width: 480px) {
        width: 92%;
    }
`;

const Wrapper = styled.div`
    max-width: 400px;
    color: white;
    margin: 0 auto;
    padding: 100px 0 10px;
    width: 100%;
`;
const OverrideGloablStyles = createGlobalStyle`
    .imageCon img {
        margin-left: auto;
        margin-right: auto;
        margin-bottom:40px;
        display: block;
    }
    .chipContainer{
        display:flex;
        max-width: 400px;
        color: white;
        background : #26252D;
        margin: 20px auto;
        padding: 10px;
        width: 100%;
        cursor: pointer;
    }
    .selctedItem{
       border: 1px solid #9D9AAC;
    }
    .buttonContainer{
        margin : 0 auto;
        width: 100%;
    }
    .pageTitle{
        font-size:20px;
        line-height:24px;
        color:#F4F4F6;
        align-items: center;
        margin-bottom:5px;
    }
    .imageConatiner{
        border-radius: 50%;
        background-color: hsl(250,10%,25%);
        height:40px;
        width:40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right:20px;
    }
    .imageConatiner img{
        border-radius: 50%;
        height:40px;
        width:40px;
    }
    .title {
        color :#9D9AAC;
        font-size:16px;
        font-Weight:700;
    }
    .subTitle {
        color :#9D9AAC;
        font-size:16px;
    }
    .centerAllign{
        text-align: center;
        margin-bottom:10px;
    }
`;
export default SelectCommunity;
